<ng-container *ngIf="searchResponse?.freightDocuments.length else emptyList">
  <virtual-scroller *ngIf="viewMode === DocumentsViewMode.table; else cardView"
                    #tableVirtualScroller class="shadow-sm rounded"
                    [items]="searchResponse.freightDocuments" [childHeight]="65"
                    (vsEnd)="vsEndReached.next($event)">
    <app-documents-table [freightDocuments]="tableVirtualScroller.viewPortItems"
                         [columns]="displayedColumns"
                         (openPDFClicked)="openPdfClicked.next($event)"
                         (acceptDeliveryClicked)="acceptDeliveryClicked.next($event)">
    </app-documents-table>
  </virtual-scroller>

  <ng-template #cardView>
    <virtual-scroller #cardVirtualScroller class="shadow-sm rounded"
                      [items]="searchResponse.freightDocuments" [childHeight]="140"
                      (vsEnd)="vsEndReached.next($event)">
      <table class="table table-borderless table-hover">
        <tbody>
        <tr *ngFor="let freightDocument of cardVirtualScroller.viewPortItems">
          <td class="border-bottom">
            <app-document-card [freightDocument]="freightDocument"
                               [columns]="displayedColumns"
                               (openPDFClicked)="openPdfClicked.next($event)"
                               (acceptDeliveryClicked)="acceptDeliveryClicked.next($event)">
            </app-document-card>
          </td>
        </tr>
        </tbody>
      </table>
    </virtual-scroller>
  </ng-template>
</ng-container>
<ng-template #emptyList>
  <div class="alert alert-light">{{ 'transportOperations.noResult' | transloco }}</div>
</ng-template>
